import { useSession } from '@wiggot/auth/hooks/useSession'
import { getUserInfo } from '../../../services'
import { updateCookieProfile } from '../../../utils'
import { NEXT_PUBLIC_TERMS_AND_CONDITIONS_LAST_VERSION } from '../../../constants'
import { useModalTermsConditionsStore } from '../../../store'
import type { IAuthUser, IProfileUser } from '../../../../interfaces/src'
import { useGet } from '../../../hooks'

interface UseInitialServicesProps {
  profile: IProfileUser
  authUser: IAuthUser
}

export const useInitialServices = ({
  profile,
  authUser
}: UseInitialServicesProps) => {
  const setIsOpenModalTermsAndConditions = useModalTermsConditionsStore(
    (state) => state.setIsOpen
  )
  const { updateProfile } = useSession()

  const rolesExist = Boolean(
    authUser?.roles && Object.keys(authUser?.roles)?.length > 0
  )

  useGet({
    queryKey: ['get-user-info'],
    queryFn: async () => {
      try {
        const response = await getUserInfo(false, authUser?.roles)

        if (response?.isSuccess && response?.data) {
          const dataUser = response?.data

          const newProfile = updateCookieProfile(profile, dataUser)
          updateProfile(newProfile)

          if (
            !newProfile?.termsAndConditions ||
            NEXT_PUBLIC_TERMS_AND_CONDITIONS_LAST_VERSION !== newProfile?.termsAndConditions
          ) {
            setIsOpenModalTermsAndConditions(true)
          }
        }

        return response.data
      } catch (error) {
        console.error(error)
      }

      return null
    },
    options: {
      enabled: rolesExist && !profile?.userId,
      retry: 0,
      staleTime: 1000 * 60 * 60 * 24 // 1 day,
    }
  })
}
